'use client';

import { c as _c } from "react/compiler-runtime";
import { FullscreenExitIcon, FullscreenIcon } from '@/app/[locale]/(worlds)/[roomId]/components/FullscreenIcons';
import ViverseButton from '@/components/ViverseButton';
import { useFullscreenStatus } from '@/hooks/useFullscreenStatus';
import { useIsFullscreenAvailable } from '@/hooks/useIsFullscreenAvailable';
import { toggleFullscreen } from '@/lib/fullscreen';
import { cn } from '@/lib/utils';
import { type ReactNode } from 'react';
type FullscreenButtonProps = {
  ariaLabel?: string;
  className?: string;
  iconClassName?: string;
  label?: ReactNode;
};
export default function FullscreenButton(t0) {
  const $ = _c(12);
  const {
    ariaLabel,
    className,
    iconClassName,
    label
  } = t0;
  const {
    isFullscreen
  } = useFullscreenStatus();
  const isFullscreenAvailable = useIsFullscreenAvailable();
  const Icon = isFullscreen ? FullscreenExitIcon : FullscreenIcon;
  if (!isFullscreenAvailable) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("group flex min-w-fit gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== iconClassName) {
    t2 = cn("[&_path]:fill-vive-primary-20 group-hover:[&_path]:fill-vive-brand-50 size-[18px] transition-colors", iconClassName);
    $[2] = iconClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== Icon || $[5] !== t2) {
    t3 = <Icon className={t2} />;
    $[4] = Icon;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== ariaLabel || $[8] !== label || $[9] !== t1 || $[10] !== t3) {
    t4 = <ViverseButton className={t1} variant="filter" aria-label={ariaLabel} onClick={_temp}>{t3}{label}</ViverseButton>;
    $[7] = ariaLabel;
    $[8] = label;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp() {
  return toggleFullscreen("standalone-iframe-wrapper");
}